import {Select, FormGroup, Paper, TextField, Typography, FormControl, InputLabel, Button, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
//import { useDispatch, useSelector } from "react-redux";
//import {createTour, getTours} from "../actions/customer"
import { fetchTours, addTour, fetchDest} from "../api/customerapi";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Tourdataentry = () => {
    var { cuser, role } = GetRole();
    const classes = useStyles();
    
    //const dispatch=useDispatch();
    const [tourData, settourData] =useState({
    tour_name: "",
    
    tour_description: "",
    tour_city: "",
    tour_destination: "",
    
    });
    const [tData, settData]=useState(null);
    const [dest, setdest]=useState([])
    const [cities, setcities]=useState([])
   const { appData, loading } = useAppData();
    const getTours = async () => {
        try{
        const data = await fetchTours();
        //const custdatalistfromdb= data.data
        settData(data.data)
    }catch(err){
        console.log(err)
      }
    }

    const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      };

    const getCities = async () => {
        try{
        const data = await fetchDest();
        //console.log(data.data);
        const citylist= data.data.map(arr => arr.dest[0] == tourData.tour_destination ? [arr.cities] : [])
        const citylist2=citylist?.filter(arr => arr.length !==0 )
        const citylist3=citylist2[0]
      
      
        setcities(citylist3 ? [...citylist3[0]] :[])
    }catch(err){
        console.log(err)
      }
       
    }

    useEffect(() => {
        getTours()
        getDest()
    }, [])

    useEffect(() => {
        
        getCities()
        
    }, [tourData])
    
    //console.log(custdatalistfromdb);
    //const updatedName= useSelector((state)=> currentID ? (state.reducerNames.find((p) => p._id ===currentID)) : null);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        // const sortedtourdatalistfromdb=tData.sort((a,b) => b.tour_id - a.tour_id);
        // const highesttourid=sortedtourdatalistfromdb[0].tour_id;
        // const newtourid = highesttourid + 1;
        const finaltourData= {...tourData, created_by:cuser};
        const addtourResponse= await addTour(finaltourData);
        // dispatch(createCustomer(finalcustData));
        //console.log(addcustResponse.data.cust_id);
        if(addtourResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Please add tour in costing sheet as well. New tour added with tour id "+addtourResponse.data.tour_id);
            window.location = ("/tourdataentry/"+addtourResponse.data.tour_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    }catch(err){
        console.log(err)
      }
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Tour</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Name"  value={tourData.tour_name} className={classes.textField} onChange={(e)=> settourData({...tourData, tour_name: e.target.value})}/>
                
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Destination *</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="primary destination" required value={tourData.tour_destination} onChange={(e)=> settourData({...tourData, tour_destination: e.target.value})}>
                    {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="city">City *</InputLabel>
                <Select displayEmpty classname={classes.textField} required labelId="city" value={tourData.tour_city} onChange={(e)=> settourData({...tourData, tour_city: e.target.value})}>
                    {cities?.map(city => {
                    return <MenuItem value={city}>{city}</MenuItem>})}
                    
                </Select>
                </FormControl>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Duration">Tour Duration (number)</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Duration" value={tourData.tour_duration} onChange={(e)=> settourData({...tourData, tour_duration: e.target.value})}>
                    <MenuItem value={0.5}>0.5 </MenuItem>
                    <MenuItem value={1}>1 </MenuItem>
               
                </Select>
                </FormControl>
                <TextField variant="outlined"  label="Start Time"  value={tourData.start_time} className={classes.textArea}  onChange={(e)=> settourData({...tourData, start_time: e.target.value})}/>
                <TextField variant="outlined"  label="End Time"  value={tourData.end_time} className={classes.textArea}  onChange={(e)=> settourData({...tourData, end_time: e.target.value})}/>
                </FormGroup>

            

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Description"  value={tourData.tour_description} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> settourData({...tourData, tour_description: e.target.value})}/>
            </FormGroup>
{role=="Admin" || role=="Product" ?(
    <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
):("")}
            
              
            </form>
        </Paper>
     );
}

export default Tourdataentry;